import { http } from "@/lib/api";
import { toast } from "sonner";

// Loads checkout.js if not present, then resolves with window.Razorpay
function loadCheckoutSdk() {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve(window.Razorpay);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(window.Razorpay);
    s.onerror = () => reject(new Error("Failed to load Razorpay"));
    document.body.appendChild(s);
  });
}

export async function openRazorpay(rzp, { orderId, name, email, phone, onSuccess, onDismiss }) {
  try {
    const Razorpay = await loadCheckoutSdk();
    const options = {
      key: rzp.key_id,
      amount: rzp.amount,
      currency: rzp.currency,
      order_id: rzp.razorpay_order_id,
      name: "Blesco",
      description: `Order ${rzp.order_number || ""}`,
      prefill: { name, email, contact: phone },
      theme: { color: "#7f77dd" },
      handler: async (response) => {
        try {
          await http.post("/payments/razorpay/verify", {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
            order_id: orderId,
          });
          toast.success("Payment successful");
          onSuccess && onSuccess();
        } catch (e) {
          toast.error("Payment verification failed. Contact support.");
        }
      },
      modal: {
        ondismiss: () => onDismiss && onDismiss(),
      },
    };
    const inst = new Razorpay(options);
    inst.open();
  } catch (e) {
    toast.error(e?.message || "Failed to open payment");
  }
}
